const error423 = {
  name: 'Erro 423',
  title: 'Assinatura temporariamente indisponível.',
  subtitle:
    'Poxa que pena! A ordem das assinaturas foi alterada por quem enviou o documento. Pedimos para que aguarde outra notificação. Assim você poderá assinar tranquilamente.',
};

export default error423;
